import TRADERBOT_EXT_1 from "./TRADERBOT_EXT_1";
export default {
  TRADERBOT_EXT_1,
};
